/**
 * ルーム異常退出ログ送信
 * - forceRoomOut からのトリガーで /api/v1/room-exit-log に POST する
 * - pagehide でも届くよう sendBeacon を優先、フォールバックで XHR
 * - 同一 roomId からの送信は 1分1回に絞る（sessionStorage）
 */
(function () {
    var API_URL = '/api/v1/room-exit-log';
    var DEDUP_INTERVAL = 60 * 1000; // 同一 roomId は1分間1回
    var STORAGE_KEY = 'vl_room_exit_last_sent';

    function _isDuplicate(roomId) {
        if (!roomId) return false;
        try {
            var raw = sessionStorage.getItem(STORAGE_KEY);
            if (!raw) return false;
            var data = JSON.parse(raw);
            var last = data[roomId];
            if (!last) return false;
            return (Date.now() - last) < DEDUP_INTERVAL;
        } catch (e) {
            return false;
        }
    }

    function _recordSent(roomId) {
        if (!roomId) return;
        try {
            var raw = sessionStorage.getItem(STORAGE_KEY);
            var data = raw ? JSON.parse(raw) : {};
            data[roomId] = Date.now();
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        } catch (e) {
            // noop
        }
    }

    function _buildPayload(info) {
        info = info || {};
        var messages = info.messages;
        var messageStr = '';
        if (Array.isArray(messages)) {
            messageStr = messages.join(' / ');
        } else if (typeof messages === 'string') {
            messageStr = messages;
        }

        var loginState = info.login_state || {};
        var roomInAt = info.room_in_at || 0;
        var elapsedMs = roomInAt > 0 ? (Date.now() - roomInAt) : -1;

        var echoState = 'unknown';
        try {
            if (window.Echo && window.Echo.connector && window.Echo.connector.pusher && window.Echo.connector.pusher.connection) {
                echoState = window.Echo.connector.pusher.connection.state || 'unknown';
            }
        } catch (e) {
            // noop
        }

        // user_id / actor_id はサーバー側で session cookie から確定するため送らない
        return {
            caller:            info.caller || '',
            title:             info.title || '',
            message:           messageStr.substring(0, 500),
            status:            info.status || '',
            room_id:           info.room_id || 0,
            elapsed_ms:        elapsedMs,
            is_rtc_success:    !!loginState.isRtcSuccess,
            is_server_success: !!loginState.isServerSuccess,
            echo_state:        echoState,
            visibility:        document.visibilityState || '',
            page_url:          location.href,
            user_agent:        navigator.userAgent,
            is_mobile:         !!info.is_mobile,
        };
    }

    function _send(payload) {
        var body = JSON.stringify(payload);

        // sendBeacon 優先（pagehide でも届く）
        try {
            if (navigator.sendBeacon) {
                var blob = new Blob([body], { type: 'application/json' });
                if (navigator.sendBeacon(API_URL, blob)) {
                    return;
                }
            }
        } catch (e) {
            // フォールバック
        }

        // XHR フォールバック
        try {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', API_URL, true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            var token = document.querySelector('meta[name="csrf-token"]');
            if (token && token.content) {
                xhr.setRequestHeader('X-CSRF-TOKEN', token.content);
            }
            xhr.send(body);
        } catch (e) {
            // 送信失敗は無視
        }
    }

    window.VLReportRoomExit = function (info) {
        try {
            var roomId = (info && info.room_id) || 0;
            if (_isDuplicate(roomId)) return;
            _recordSent(roomId);

            var payload = _buildPayload(info);
            _send(payload);
        } catch (e) {
            // 送信失敗は無視
        }
    };
})();
